import { useState, useEffect } from 'react'

export function useCountdown(initialMinutes: number = 20) {
  const [timeLeft, setTimeLeft] = useState(initialMinutes * 60)

  useEffect(() => {
    // Check if there's a saved end time in localStorage
    const savedEndTime = localStorage.getItem('sibo_countdown_end')
    const now = new Date().getTime()

    if (savedEndTime) {
      const remaining = Math.floor((parseInt(savedEndTime) - now) / 1000)
      if (remaining > 0) {
        setTimeLeft(remaining)
      } else {
        // Reset if expired
        const newEndTime = now + initialMinutes * 60 * 1000
        localStorage.setItem('sibo_countdown_end', newEndTime.toString())
        setTimeLeft(initialMinutes * 60)
      }
    } else {
      const newEndTime = now + initialMinutes * 60 * 1000
      localStorage.setItem('sibo_countdown_end', newEndTime.toString())
    }

    const interval = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(interval)
          return 0
        }
        return prev - 1
      })
    }, 1000)

    return () => clearInterval(interval)
  }, [initialMinutes])

  const minutes = Math.floor(timeLeft / 60)
  const seconds = timeLeft % 60

  return {
    minutes: minutes.toString().padStart(2, '0'),
    seconds: seconds.toString().padStart(2, '0'),
    isExpired: timeLeft === 0,
  }
}
